import React from 'react';
import { YoutubeShortsBlockType } from '../../../../../../../types/YoutubeShortsBlockType';
import { ShortsCarousel } from '../../../../ShortsCarousel/ShortsCarousel';
import { ArticleBlockContentGridCol } from './ArticleBlockContentGridCol';
import { BlockContentContext } from '../../../BlockContent.utils';

interface ShortsCarouselSerializerProps {
  value: YoutubeShortsBlockType;
}

const ShortsCarouselBlock = ({ value }: ShortsCarouselSerializerProps) => (
  <ShortsCarousel videos={value.videos} title={value.title} background={value.background} />
);

export const ShortsCarouselSerializer = (context: BlockContentContext = BlockContentContext.Stripped) => {
  if (context === BlockContentContext.Article) {
    return ({ value }: ShortsCarouselSerializerProps) => (
      <ArticleBlockContentGridCol>
        <ShortsCarouselBlock value={value} />
      </ArticleBlockContentGridCol>
    );
  }

  return ({ value }: ShortsCarouselSerializerProps) => <ShortsCarouselBlock value={value} />;
};
